"use strict";
var indexCtrl = require('search/controllers/indexCtrl');
var navCtrl = require('common/controllers/navCtrl');
var app = angular.module('search', ['templates', 'ui.bootstrap', 'angular-table', 'ngFlash']);
app.controller('indexCtrl', ['$scope', '$q', '$http', '$filter', 'Flash', '$uibModal', indexCtrl]);
app.controller('navCtrl', ['$scope', navCtrl]);
module.exports = app;
